import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';
import { HttpClient } from '@angular/common/http';
import { parse } from 'flatted';

@Injectable({
  providedIn: 'root'
})
export class PermissoesService extends GenericService {

  permissoesRaw = localStorage.getItem('direitos');


  private readonly urlDireitos = 'assets/direitos.json';

  constructor(http: HttpClient) {
    super(http, 'permissao');
  }

  getPermissoes(): Observable<any[]> {
    return this.http.get<any[]>(this.urlDireitos);
  }

  findByGrupo(id: number): Observable<any> {
    return this.http.get(`${this.url_base}/${this.prefixo}/grupo/${id}`);
  }

  can(flag) {
    let permissoesRaw = localStorage.getItem('direitos');
    let permissoes = permissoesRaw ? parse(permissoesRaw) : [];
    let permission = permissoes.find(item => (item.data.flag  == flag));
    if (permission != undefined) {
      return true;
    } else {
      return false;
    }
  }

  
}
